module.exports = __webpack_public_path__ + "img/loader-circle.2c0c5093.gif";